import template from "./quote-share-modal.html";

const QuoteShareModalComponent = {
  bindings: {
    resolve: "<",
    close: "&",
    dismiss: "&",
  },
  template: template,
  controller: class QuoteShareModalController {
    /* @ngInject */
    constructor($rootScope, $window, $state, $filter) {
      this.$rootScope = $rootScope;
      this.$window = $window;
      this.$state = $state;
      this.$filter = $filter;
    }

    async $onInit() {
      this.shareByDefault = this.resolve.shareByDefault;
      this.quote = this.resolve.quote;
      this.sharedUrl = `${this.$rootScope.organization.getDomainUrl()}/show/${
        this.quote.token
      }`;
      this.addressees = this.quote.quoteContacts
        .map((quoteContact) => encodeURIComponent(quoteContact.contact.email))
        .join(";");
      this.subject = this.$filter("trans")("quoteShareModal.email.subject", [
        this.$rootScope.organization.name,
      ]);
      this.body = this.$filter("trans")("quoteShareModal.email.body", [
        this.quote.contact.firstName,
        this.sharedUrl,
      ]);
      if (this.shareByDefault) {
        this.shared = true;
        if (!this.quote.isShared()) await this.quote.share();
      } else {
        this.shared = this.quote.shared;
      }
    }

    async toogleShared() {
      if (this.shared) await this.quote.share();
      else await this.quote.unshare();
    }

    sendToGmail() {
      const url = `https://mail.google.com/mail/?view=cm&ui=2&tf=0&fs=1&to=${this.addressees}&su=${this.subject}&body=${this.body}`;
      this.$window.open(url, "_blank");
    }

    sendToEmail() {
      const url = `mailto:${this.addressees}?subject=${this.subject}&body=${this.body}`;
      this.$window.open(url, "_blank");
    }

    close() {
      this.dismiss({ $value: "cancel" });
    }
  },
};

export default QuoteShareModalComponent;
